import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-[#D2D2D7] bg-transparent text-[#1D1D1F] hover:border-[#A1A1A6] focus-visible:outline-none focus-visible:border-[#0071E3] focus-visible:ring-[3px] focus-visible:ring-[rgba(0,113,227,0.15)] aria-[invalid=true]:border-[#FF3B30] placeholder:text-[#A1A1A6] placeholder:font-normal px-3 py-2 text-base shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
